import React, { useState } from 'react';

import { Images } from 'util/images';
import * as appConstants from 'util/appConstants';
import { SearchSelect } from 'components/searchSelect/searchSelect';
import { Input } from 'reactstrap';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableHeading,
  TableData,
  SortArrowImage,
  RankListContainer,
} from './style';

export function RankList(props) {
  let sortedList = props.rankList.slice().sort((a, b) => {
    if (a?.eligibleStatus?.eligible === false) return 1;
    if (b?.eligibleStatus?.eligible === false) return -1;
    if (props.isTournament && a.rating === null) return 1;
    if (props.isTournament && b.rating === null) return -1;
    return props.isTournament ? b.rating - a.rating : b.maxScore - a.maxScore;
  });

  const languages = appConstants.contestLanguages;

  const [rankList, setRankList] = useState(props.rankList);
  const [filteredRankList, setFilteredRankList] = useState(sortedList);
  const [listForSearch, setListForSearch] = useState(props.rankList);
  const [isAscending, setIsAscending] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(appConstants.contestLanguages[0]);

  const sortRankList = () => {
    let sortedData = filteredRankList.slice().sort((a, b) => {
      return isAscending ? b.maxScore - a.maxScore : a.maxScore - b.maxScore;
    });

    setFilteredRankList(sortedData);
    setIsAscending(!isAscending);
  };

  const sortRatings = () => {
    let sortedData = filteredRankList.slice().sort((a, b) => {
      if (a?.eligibleStatus?.eligible === false) return 1;
      if (b?.eligibleStatus?.eligible === false) return -1;
      if (a.rating === null) return isAscending ? 1 : -1;
      if (b.rating === null) return isAscending ? -1 : 1;
      return isAscending ? b.rating - a.rating : a.rating - b.rating;
    });

    setFilteredRankList(sortedData);
    setIsAscending(!isAscending);
  };

  const searchByName = (event) => {
    let updatedList = [];
    updatedList = listForSearch.filter((participants) => {
      return participants.name.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
    });
    if (updatedList.length) {
      setFilteredRankList(updatedList);
      setRankList(updatedList);
    } else {
      setFilteredRankList(updatedList);
      setRankList(props.rankList);
    }
  };

  const searchByLanguage = (language) => {
    let updatedList = [];
    if (language) {
      if (!language.value) {
        setSelectedLanguage(appConstants.contestLanguages[0]);
        setFilteredRankList(rankList);
        setListForSearch(rankList);
      } else {
        updatedList = rankList.filter((participants) => {
          if (language.value.toLowerCase() !== appConstants.contestLanguages[1].value.toLowerCase()) {
            if (participants.language.toLowerCase() === language.value.toLowerCase()) {
              return participants;
            } else return false;
          } else if (participants.language.toLowerCase() === language.value.toLowerCase()) {
            return participants;
          } else return false;
        });
        setSelectedLanguage(language);
        setFilteredRankList(updatedList);
        setListForSearch(updatedList);
      }
    }
  };

  const renderTableBody = () => {
    return filteredRankList.map((item, index) => {
      return (
        <TableRow
          isSelectedRow
          key={index}
          onClick={() => props.history.push(`/cms/candidateInfo/${item.accountId}/${props.contestId}`)}
        >
          <TableData>{++index}</TableData>
          <TableData>{item.name}</TableData>
          <TableData>{item.email}</TableData>
          <TableData>{item.city ? item.city : null}</TableData>
          <TableData>{item.linkedIn ? item.linkedIn : null}</TableData>
          <TableData>{item.github ? item.github : null}</TableData>
          <TableData>{item.languageVersion}</TableData>
          <TableData>
            {props.isTournament
              ? item?.eligibleStatus?.eligible === true
                ? item.rating === null
                  ? 'Not ranked'
                  : Math.round(item.rating)
                : item?.eligibleStatus?.reason
              : item.maxScore}
          </TableData>
          <TableData>{item.numSubmits}</TableData>
        </TableRow>
      );
    });
  };

  const renderTableHeading = () => {
    return (
      <TableRow isHeading>
        <TableHeading>#</TableHeading>
        <TableHeading>Name</TableHeading>
        <TableHeading>Email</TableHeading>
        <TableHeading>City</TableHeading>
        <TableHeading>LinkedIn</TableHeading>
        <TableHeading>GitHub</TableHeading>
        <TableHeading>
          <SearchSelect
            clearable={false}
            options={languages}
            onChange={searchByLanguage}
            value={selectedLanguage}
            placeholder="Language"
            className="VirtualizedSelectCustom"
          />
        </TableHeading>
        <TableHeading
          onClick={() => {
            if (props.isTournament) {
              sortRatings();
            } else {
              sortRankList();
            }
          }}
          className="score"
          scope="col"
        >
          {props.isTournament ? 'Rating' : 'Score'}
          <SortArrowImage alt="arrow" src={isAscending ? Images.downArrow : Images.upArrow} />
        </TableHeading>
        <TableHeading>Submits</TableHeading>
      </TableRow>
    );
  };

  return (
    <RankListContainer>
      <Input type="text" onChange={searchByName} placeholder="Search by name..." />
      <Table>
        <TableHead>{renderTableHeading()}</TableHead>
        <TableBody>{renderTableBody()}</TableBody>
      </Table>
    </RankListContainer>
  );
}
